import { ConnectedService } from './types'

export enum CONNECTED_SERVICES {
  NINE_AM_HEALTH = '9am_health',
}

export const CONNECTED_SERVICE_NAMES: Record<ConnectedService, string> = {
  [CONNECTED_SERVICES.NINE_AM_HEALTH]: '9amHealth',
}
